// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"165":"css/twill","858":"css/core"}[chunkId] + ".css";
};